import * as React from 'react';
import type { SVGProps } from 'react';

const TruckSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon/Truck">
      <path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M11 2.00012H0V13.0001H2C2 14.1047 2.89543 15.0001 4 15.0001C5.10457 15.0001 6 14.1047 6 13.0001H10C10 14.1047 10.8954 15.0001 12 15.0001C13.1046 15.0001 14 14.1047 14 13.0001H16V8.00012C16 6.34327 14.6569 5.00012 13 5.00012H11V2.00012ZM11 7.00012V9.00012H14V7.00012H11Z" fill="#616061"/>
    </g>
  </svg>
);

export default TruckSvg;